import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function OnboardingBodyWizardIntro() {
    return (
        <OnboardingBody title='Let’s design your sales process'>
            <div>
                <p>
                    We’re going to ask you a few questions about your business and use your answers
                    to automatically define a sales process.
                </p>
                <p>
                    After this wizard, we’ll launch Nutshell’s sales automation designer, where you
                    can fine-tune things.
                </p>
            </div>
        </OnboardingBody>
    );
}
